export const USER_DIRECTORY_QUERY_MAX_CHARS = 80;

export function normalizeDirectoryQuery(raw) {
  if (typeof raw !== "string") return "";
  const collapsed = raw.trim().replace(/\s+/g, " ");
  if (!collapsed) return "";
  return collapsed.slice(0, USER_DIRECTORY_QUERY_MAX_CHARS);
}

export function parseDirectoryPage(raw) {
  const numeric = Number.parseInt(raw, 10);
  if (!Number.isSafeInteger(numeric) || numeric < 1) return 1;
  return numeric;
}

export function readDirectorySearchParams(searchParams) {
  const q = normalizeDirectoryQuery(searchParams.get("q") || "");
  const page = parseDirectoryPage(searchParams.get("page"));
  return { q, page };
}

export function buildDirectorySearchParams({ q, page }) {
  const params = new URLSearchParams();
  const normalized = normalizeDirectoryQuery(q || "");
  if (normalized) params.set("q", normalized);
  if (page && page > 1) params.set("page", String(page));
  return params;
}

export function buildDirectoryFetchParams({ q, page, pageSize }) {
  const params = {};
  const normalized = normalizeDirectoryQuery(q || "");
  if (normalized) params.q = normalized;
  if (page && page > 1) params.page = page;
  if (pageSize) params.page_size = pageSize;
  return params;
}
